export const GetWeek = function (d) {
    var target = new Date(d.valueOf());
    var dayNr = (d.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 5);
    var firstThursday = target.valueOf();
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    target.setMonth(0, 1);
    if (target.getDay() != 4) {
        target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }

    return (1 + Math.ceil((firstThursday - target) / 604800000));
}

const getWeeksDiff = (startDate, endDate) => {
    const msInWeek = 1000 * 60 * 60 * 24 * 7;
    return Math.round(Math.abs(endDate - startDate) / msInWeek);
}

export const GetAllWeeks = () => {
    let weekList = []
    let sDate = new Date("01/01/" + new Date().getFullYear()).getTime()
    let eDate = new Date().getTime()
    let numberOfWeeks = getWeeksDiff(sDate, eDate);
    for (let i = 0; i < numberOfWeeks; i++) {
        weekList.push('Week ' + (i + 1))
    }
    return weekList
}